import { createAction, props } from '@ngrx/store';
import { Course, ErrorModel, StepBlock, StepsCategoryModel } from '@tekman/onmat/models';

export const loadCourses = createAction('[Courses/API] Load Courses');
export const loadCoursesSuccess = createAction('[Courses/API] Load Courses Success', props<{ courses: Course[] }>());
export const loadCoursesFailure = createAction('[Courses/API] Load Courses Failure', props<{ error: ErrorModel }>());

export const loadStepBlocksByCourse = createAction('[Courses/API] Load Steps By Course', props<{ courseId: string; groupId: string }>());
export const loadStepBlocksByCourseSuccess = createAction(
  '[Courses/API] Load Steps By Course Success',
  props<{ courseId: string; blocks: StepBlock[] }>()
);
export const loadStepBlocksByCourseFailure = createAction('[Courses/API] Load Steps By Course Failure', props<{ error: ErrorModel }>());

export const loadSteps = createAction('[Courses/API] Load Steps', props<{ stepId: string; groupId: string }>());
export const loadStepsSuccess = createAction('[Courses/API] Load Steps Success', props<{ stepsCategory: StepsCategoryModel }>());
export const loadStepsFailure = createAction('[Courses/API] Load Steps Failure', props<{ error: ErrorModel }>());
